{
  "es": {
    "sales": {
      "actions": {
        "assign_lead": "Asignar interesado",
        "publish": "Publicar",
        "remove_lead_from_deal": "Quitar interesado de la oportunidad",
        "unpublish": "Despublicar",
        "update_status": "Actualizar estado",
        "upload_document": "Subir contrato",
        "view_contracts": "Ver contratos"
      },
      "attributes": {
        "status": "Estado"
      },
      "labels": {
        "assign_customer": "Asignar cliente",
        "assign_customer_mark_sold": "Asignar cliente para marcar como vendida",
        "assign_lead_to_unit": "Asignar interesado a la unidad",
        "assigned_by": "Asignado por",
        "contracts": "Contratos",
        "expiry_date": "Fecha de vencimiento de la reserva",
        "go_to_unit_part_1": "Esta unidad se vendió. Si quieres actualizar el estado, tienes que ir a la",
        "go_to_unit_part_2": "y desasignar primero al cliente allí como medida de seguridad.",
        "interested_leads": "{count} interesados",
        "internal_note": "Nota interna",
        "latest_phase": "Última fase",
        "lead_existing": "Interesado existente",
        "lead_new": "Interesado nuevo",
        "leads_count": "{count} interesados",
        "mark_as_sold": "Marcar como vendida",
        "not_published_sales_partners": "No publicada para los colaboradores de ventas",
        "not_shown_interest": "Este interesado no ha mostrado interés en ninguna unidad",
        "note_explainer": "Esta nota solo es visible para tu equipo",
        "publish_unit": "Publicar 1 unidad para todos los colaboradores de ventas | Publicar {count} unidades para todos los colaboradores de ventas ",
        "published_sales_partners": "Publicada para los colaboradores de ventas",
        "reserved_by": "Reservada por",
        "reserved_warning": "Esta unidad está reservada actualmente por {lead_name}. Si marcas esta unidad como vendida, se cancelará esta reserva.",
        "sales": "Ventas",
        "selling_price": "Precio de venta",
        "selling_price_max": "Precio de venta máximo",
        "selling_price_min": "Precio de venta mínimo",
        "sold_date": "Vendido el",
        "sorting": {
          "deal_lead_group_name": "Interesado",
          "deal_status": "Estado",
          "name": "Unidad"
        },
        "status": "Estado",
        "statuses": {
          "available": "Disponible",
          "interested": "Interesada",
          "lost": "Perdida",
          "reserved": "Reservada",
          "sold": "Vendida"
        },
        "tab_sales_documents": "Documentos",
        "tab_sales_tickets": "Conversaciones",
        "tab_sales_units": "Unidades",
        "unit": "Unidad",
        "unit_information_page": "página de información de la unidad",
        "unit_sales_status_header": "Esta unidad está en venta",
        "unpublish_unit": "Despublicar 1 unidad para todos los colaboradores de ventas | Despublicar {count} unidades para todos los colaboradores de ventas ",
        "update_sales_status": "Actualizar el estado de venta de la unidad",
        "upload_sales_doc": "Subir contrato"
      },
      "toasts": {
        "lead_assigned": "Interesado asignado"
      },
      "validation": {
        "already_reserved_sold": "¡Esta unidad ya está reservada para otro interesado!",
        "already_reserved_sold_info": "Si estás seguro de que quieres cambiar el estado del interesado actual, primero tienes que cambiar el estado de la oportunidad que tiene prioridad en este momento. Una vez que hayas cambiado el estado de la otra oportunidad, puedes volver y actualizar el estado con seguridad.",
        "need_sold_date": "Se necesita la fecha de esta venta",
        "reserved_expiry_date": "Se necesita una fecha de vencimiento para esta reserva"
      }
    }
  }
}
